import {
  Create,
  SimpleForm,
  TextInput,
  BooleanInput,
  usePermissions,
  useNotify,
} from "react-admin";

const CourseCreate = (props) => {
  const { permissions = [] } = usePermissions();
  const notify = useNotify();

  if (
    !(
      permissions.includes("user-guides.create") ||
      permissions.includes("user-guides.*") ||
      permissions.includes("*")
    )
  ) {
    return null;
  }

  return (
    <Create title="Create Course" {...props} redirect="list">
      <SimpleForm
        onSuccess={() =>
          notify("Course created successfully", { type: "success" })
        }
      >
        <TextInput source="course_name" required />
        <TextInput source="description" multiline />
        <BooleanInput source="is_active" defaultValue={true} />
      </SimpleForm>
    </Create>
  );
};

export default CourseCreate;